import { parseCookies } from '@cian/utils';
import * as React from 'react';
import { render } from 'react-dom';
import * as superagent from 'superagent';

import { IExtendedRegion } from './user_location_switcher';

function toggleActiveGeoPopup(className: string) {
  const toggleElement = document.querySelector(`.${className}`);

  if (toggleElement) {
    if(toggleElement.classList.contains(`${className}--active`)) {
      toggleElement.classList.remove(`${className}--active`);
    } else {
      toggleElement.classList.add(`${className}--active`);
    }
  }
}

function geoReady() {
  (document.querySelector('.cf_header-bottom') as HTMLDivElement)
      .classList.add('cf_header-bottom--geo_visible');
}

function getAllRegions(): Promise<IExtendedRegion[]> {
  return new Promise((resolve, reject) => {
    superagent
      .get('/cian-api/site/v1/get-regions/')
      .send()
      .end((error, response) => {
        if (error) {
          reject(error);
        }

        resolve(response.body);
      });
  });
}

function getRegionById(id: number): Promise<IExtendedRegion> {
  return new Promise((resolve, reject) => {
    superagent
      .get('/cian-api/site/v1/get-region/')
      .query({ regionId: id })
      .send()
      .end((error, response) => {
        if (error) {
          reject(error);
        }

        resolve(response.body);
      });
  });
}

function getDetectedRegion(): Promise<IExtendedRegion> {
  return new Promise((resolve, reject) => {
    superagent
      .get('/cian-api/site/v1/get-region-request/')
      .send()
      .end((error, response) => {
        if (error) {
          reject(error);
        }

        resolve(response.body);
      });
  });
}

const cookieGeoNames = {
  session: 'session_region_id',
  forever: 'forever_region_id',
};

export default function initLocationSwitcher() {
  (window as any).renderLocationSwitcher = function(container: Element) {
    const cookies = parseCookies(document.cookie);
    const regionCookies = cookies[cookieGeoNames.session] || cookies[cookieGeoNames.forever];

    if (regionCookies) {
      return;
    }

    require.ensure(['./user_location_switcher'], () => {
      let UserLocationSwitcher = require('./user_location_switcher').default;

      render(
        <UserLocationSwitcher
          geoReady={geoReady}
          togglePopup={toggleActiveGeoPopup}
          getAllRegions={getAllRegions}
          getRegionById={getRegionById}
          getDetectedRegion={getDetectedRegion}
        />,
        container
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/bundles/user_location_switcher/index.tsx